import { gatewayInstance } from "../axiosInstance";
import { authServerUrl, SERVICE_ENDPOINT } from "../const";

export const saveArticle = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/create`,
      data
    );
    console.log(response);
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const updateArticle = async (data) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/update`,
      data
    );
    console.log(response);
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getArticles = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles`
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getDeletedArticles = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/deleted`
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getArticle = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/by-id/${id}`
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteArticle = async (id) => {
  try {
    await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/delete/${id}`
    );
  } catch (e) {
    console.error(e);
  }
};

export const recoverArticle = async (id) => {
  try {
    await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/recover/${id}`
    );
  } catch (e) {
    console.error(e);
  }
};


export const setViewCount = async (id) => {
  try {
    await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/count/${id}`
    );
  } catch (e) {
    console.error(e);
  }
};

export const duplicateCheckArticle = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/help-center/articles/check-dup`,
      data
    );
    console.log(response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};